export const STEP_PROPERTIES = {
  isCompleted: 'isCompleted',
  isDisabled: 'isDisabled',
  isClicked: 'isClicked',
  hasBeenDeleted: 'hasBeenDeleted',
  allStepsCompletedOnce: 'allStepsCompletedOnce'
};

export const STEPPER_CONTAINER_ID = 'stepperContainer';
